module.exports = __webpack_public_path__ + "static/media/main--2.c44c5934.png";